module.exports = __webpack_public_path__ + "img/20190829151146360截图20190829133224750.61194025.jpg";